module.exports = __webpack_public_path__ + "static/media/five.d16d8d3f.svg";